import React, { useState, useEffect } from "react";
import { Table, Spin, Alert, Tag } from "antd";

import moment from "moment";
import axios from "axios";

const ListOfPagosByVerification = ({ verificacionId }) => {
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPagos = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/pagos/verificacion/${verificacionId}`);
        setPagos(response.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (verificacionId) {
      setLoading(true);
      fetchPagos();
    }
  }, [verificacionId]);

  const columns = [
    {
      title: "Fecha",
      dataIndex: "Fecha",
      key: "Fecha",
      render: (text) => moment(text).format("DD/MM/YYYY"),
    },
    {
      title: "Monto",
      dataIndex: "Monto",
      key: "Monto",
      align: "right",
      render: (text) =>
        `$${Number(text)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      title: "Moneda",
      dataIndex: "Moneda",
      key: "Moneda",
    },
    {
      title: "Método",
      dataIndex: "Metodo",
      key: "Metodo",
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (status) => {
        // 1=Pendiente, 2=Confirmado, 3=Rechazado
        // needs tags
        switch (status) {
          case 1:
            return <Tag color="blue">Pendiente</Tag>;
          case 2:
            return <Tag color="green">Confirmado</Tag>;
          case 3:
            return <Tag color="red">Rechazado</Tag>;
          default:
            return <Tag color="default">Desconocido</Tag>;
        }
      },
    },
    {
      title: "Referencia",
      dataIndex: "Referencia",
      key: "Referencia",
    },
    {
      title: "Notas",
      dataIndex: "Notas",
      key: "Notas",
    },
  ];

  if (loading) {
    return <Spin tip="Cargando pagos..." />;
  }

  if (error) {
    return <Alert message="Error" description={error} type="error" showIcon />;
  }

  return (
    <div>
      <Table
        columns={columns}
        dataSource={pagos}
        rowKey="PagoID"
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
        }}
        scroll={{
          x: "max-content",
        }}
      />
    </div>
  );
};

export default ListOfPagosByVerification;
